import { post } from "../util/http";
import Vue from "vue";
import Vuex from "vuex";
import { format } from "@/util/time";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    timMessageReceived: [],
    isEnterPrivateChat: false,
    enterUserChatFlag: 1,
    userChatId: 0,
    userChatName: "",
    userMessageList: [],
    isLoadingMore: false,
    noMoreMsg: false,
    groupMessageList: [],
    isFollowed: 0,
    groupInfo: [],
    fanGroup: [],
    anchorId: 0,
    anchorInfo: {},
    fansGroups: [],
    chatList: [],
    privateMessageList: [],
    quizPrompt: {},
    timGuessList: [],
    toast: [],
    deleteMessageId: null,
    disabledSendMsg: false,
    giftAnimation: {},
    isContinuousGift: false,
    continuousGift: [],
    playerStatus: 1,
    hot: 0,
    colorfulTextColor: ["#113BD0", "#E41EB1", "#FF6B00"],
    loginRepData: {},
    messageList: [],
    welcomeMsg: [],
    isTimReady: false,
    liveAd: "",
    liveAdContact: [],
    liveAdContactMain: "",
    isCheckinDialog: false,
    isNeedRefresh: false,
    ticketAnchor: {},
    ticketPayDialog: false,
    ticket: 0,
    userBackpack: [],
    isCheckinDialog: false,
    props: {
      speaker: 0,
      colorful1: 0,
      colorful2: 0,
      colorful3: 0,
    },
    isLiveLogout: false,
    wrapHeight: "",
    isNavShow: false,
    navCategory: {
      firstId: 0,
      secondId: 0,
      name: "全部直播",
    },
    // selectCate: {
    //   id: 0,
    //   name: '全部直播',
    //   sub: {
    //     id: 0,
    //     name: '全部'
    //   }
    // },
    isHomePage: false,
    showLogin: false,
    showRegister: false,
    showBarrage: true,
    userInfo: {
      id: 0,
      diamond: 0,
      gold: 0,
    },
    userAsset: {},
    isShow: false,
    showDynamicRel: false,
    categories: [],
    appConfig: {},
    defaultAvatar: require("./moren@2x.png"),
    pageConfig: {},
    loginType: "login",
    tourist: {},
    tim: null,
    unReadCount: 0,
    msgLiveAnchor: {},
    isOpenAnimation: true,
    locales: [
      {
        code: "zh-CN",
        name: "CN",
      },
      {
        code: "en-US",
        name: "EN",
      },
    ],
    locale: "zh-CN",
    isClone: false,
    liveBarrage: [],
    userState: 12,
    isLiving: false,
    chips: [],
    gifts: JSON.parse(sessionStorage.getItem("gifts") || "{}"),
    chatConfig: {
      // 累计触发风控禁言多久 单位（小时）
      total_trigger_banned: 1,
      // 连续触发风控 禁言多久 单位（小时）
      continue_trigger_banned: 1,
      // 连续触发风控次数
      continue_trigger_num: 2,
      id: 1,
      // 链接设置
      link_set: 0,
      // 连续数字消息条数
      num_msg_count: 2,
      // 单挑消息连续数字长度
      single_msg_num_length: 3,
      // 发言间隔 单位 秒
      speak_rate: 1,
      // 连续触发风控开关 0 关闭 1 开启
      toggle_continue_trigger: 1,
      // 链接设置开关 0 关闭 1 开启
      toggle_link_set: 1,
      // 连续数字消息条数开关 0 关闭 1 开启
      toggle_num_msg_count: 1,
      // 单挑消息连续数字长度开关 0 关闭 1 开启
      toggle_single_msg: 1,
      // 发言间隔开关 0 关闭 1 开启
      toggle_speak_rate: 1,
      // 累计触发风控开关 0 关闭 1 开启
      toggle_total_trigger: 1,
      // 累计触发风控次数
      total_trigger: 3,
    },
    //赛事详情页事件回发的数据
    matchDetailData: {
      //主动触发的modified数据
      modified: [],
      //主动推送过来的消息数据
      received: {
        textLive: "",
        scoreLive: "",
        statsLive: "",
      },
    },
  },
  getters: {
    unreadTotal(state) {
      let arr = state.chatList.filter((e) => e.anchor_id !== state.userInfo.id);
      let total = arr.reduce((acr, cur) => acr + cur.unread_num, 0);
      if (total > 99) {
        return (total = "99+");
      } else {
        return total;
      }
    },
    userState(state) {
      return state.userState;
    },
    appConfig(state) {
      return state.appConfig;
    },
    isLiving(state) {
      return state.isLiving;
    },
    chips(state) {
      return state.chips;
    },
    gifts(state) {
      return state.gifts;
    },
    chatConfig(state) {
      return state.chatConfig;
    },
  },
  mutations: {
    //离开赛事详情页面时清空一次历史数据
    clearMatchLiveData(state) {
      state.matchDetailData.modified = [];
      state.matchDetailData.received = {
        textLive: "",
        scoreLive: "",
        statsLive: "",
      };
      // console.log('旧数据已清理~');
    },
    //获取赛事modify事件回发过来的数据
    getMatchModified(state, event) {
      //最后一个data有可能不存在
      if (typeof event.data[0].payload.data == "undefined") {
        return false;
      }
      let payload_data = event.data[0].payload.data;
      //有时候传过来的只是一对转义过的一对双引号
      if (payload_data.length <= 4) {
        return false;
      }
      //有时候传过来的只是一对转义过的一对双引号
      if (payload_data.length > 4) {
        console.log("modified: payload_data", payload_data);
        console.log("data_match", state);
        //将不是赛事页面所需要的回调的值全部扔掉
        if (
          payload_data.indexOf("textLive") != -1 ||
          payload_data.indexOf("scoreLive") != -1 ||
          payload_data.indexOf("statsLive") != -1 ||
          payload_data.indexOf("lineupLive") != -1 ||
          payload_data.indexOf("empty") > 0
        ) {
          state.matchDetailData.modified.push(event);
        }
      }
    },
    //获取赛事modify事件回发过来的数据
    getMatchReceived(state, item) {
      //读取回发标识，针对性的发给相关业务去处理，一次可能会发多条数据过来
      //不管多少条，每次都以最后一条识别出来的数据为准
      //event.data.forEach((item, index) => {
      //最后一个data有可能不存在
      if (typeof item.payload.data == "undefined") {
        return false;
      }
      let payload_data = item.payload.data;
      console.log("received: payload_data", payload_data);
      console.log("data_match", state);
      if (payload_data.matchId != data.matchId) {
        return;
      }

      //有时候传过来的只是一对转义过的一对双引号
      if (payload_data.length <= 4) {
        return false;
      }
      //分类组装数据，确保每一类只有一条数据给前台识别
      if (payload_data.indexOf("textLive") != -1) {
        state.matchDetailData.received.textLive = payload_data;
      }
      if (payload_data.indexOf("scoreLive") != -1) {
        state.matchDetailData.received.scoreLive = payload_data;
      }
      if (payload_data.indexOf("statsLive") != -1) {
        state.matchDetailData.received.statsLive = payload_data;
      }
      // });
    },

    changeTimMessageReceived(state, arr) {
      state.timMessageReceived = arr;
    },
    changeIsEnterPrivateChat(state, boo) {
      state.isEnterPrivateChat = boo;
    },
    changeEnterUserChatFlag(state, num) {
      state.enterUserChatFlag = num;
    },
    changeUserChatId(state, num) {
      state.userChatId = num;
    },
    changeUserChatName(state, str) {
      state.userChatName = str;
    },
    changeUserMessageList(state, arr) {
      state.userMessageList = arr;
    },
    changeIsLoadingMore(state, boo) {
      state.isLoadingMore = boo;
    },
    changeNoMoreMsg(state, boo) {
      state.noMoreMsg = boo;
    },
    changeGroupMessageList(state, arr) {
      state.groupMessageList = arr;
    },
    changeIsFollowed(state, num) {
      state.isFollowed = num;
    },
    changeGroupInfo(state, arr) {
      state.groupInfo = arr;
    },
    changeFanGroup(state, arr) {
      state.fanGroup = arr;
    },
    changeAnchorId(state, val) {
      state.anchorId = val;
    },
    changeAnchorInfo(state, obj) {
      state.anchorInfo = obj;
    },
    changeFansGroups(state, arr) {
      state.fansGroups = arr;
    },
    changeChatList(state, arr) {
      state.chatList = arr;
    },

    changePrivateMessageList(state, arr) {
      state.privateMessageList = arr;
    },
    pushPrivateMessageList(state, obj) {
      state.privateMessageList.push(obj);
    },
    changeQuizPrompt(state, obj) {
      state.quizPrompt = obj;
    },
    changeGuessList(state, arr) {
      state.timGuessList = arr;
    },
    pushToast(state, obj) {
      state.toast.push(obj);
    },
    changeDeleteMessageId(state, msgId) {
      state.deleteMessageId = msgId;
    },
    toggleDisabledSendMsg(state, boo) {
      state.disabledSendMsg = boo;
    },
    changeGiftAnimation(state, obj) {
      state.giftAnimation = obj;
    },
    toggleContinuousGift(state, boo) {
      state.isContinuousGift = boo;
    },
    changeContinuousGift(state, obj) {
      state.continuousGift[0] = obj;
    },
    changePlayerStatus(state, number) {
      state.playerStatus = number;
    },
    changeHot(state, number) {
      state.hot = number;
    },
    changeLoginRepData(state, obj) {
      state.loginRepData = obj;
    },
    changeLastHitMessageList(state, val) {
      state.messageList[state.messageList.length - 1].hit = val;
    },
    deleteClearMessageList(state, chat_id) {
      state.messageList = state.messageList.filter(
        (item) => item.id != chat_id
      );
    },
    deleteBannedMessageList(state, uid) {
      state.messageList = state.messageList.filter(
        (item) => item.user_id != uid
      );
    },
    changeMessageList(state, arr) {
      state.messageList = arr;
    },
    pushMessageList(state, obj) {
      state.messageList.push(obj);
    },
    pushWelcomeMsg(state, obj) {
      state.welcomeMsg.push(obj);
    },
    toggleTimReady(state, boo) {
      state.isTimReady = boo;
    },
    changeLiveAd(state, str) {
      state.liveAd = str;
    },
    changeLiveAdContact(state, arr) {
      state.liveAdContact = arr;
    },
    changeLiveAdContactMain(state, str) {
      state.liveAdContactMain = str;
    },
    toggleCheckinDialog(state, boo) {
      state.isCheckinDialog = boo;
    },
    toggleIsNeedRefresh(state, boo) {
      state.isNeedRefresh = boo;
    },
    changeTicketAnchor(state, obj) {
      state.ticketAnchor = obj;
    },
    toggleTicketPayDialog(state, boo) {
      state.ticketPayDialog = boo;
    },
    changeUserBackpack(state, arr) {
      state.userBackpack = arr;
    },
    changeTicket(state, num) {
      state.ticket = num || 0;
    },
    toggleCheckinDialog(state, boo) {
      state.isCheckinDialog = boo;
    },
    initialChatConfig(state, obj) {
      state.chatConfig = obj || {};
    },
    changeProps(state, obj) {
      state.props = obj;
    },
    changeWrapHeight(state, str) {
      state.wrapHeight = str;
    },
    toggleLiveLogout(state, boo) {
      state.isLiveLogout = boo;
    },
    toggleNavShow(state) {
      state.isNavShow = !state.isNavShow;
    },
    changeNavCategoryName(state, obj) {
      state.navCategory = {
        ...state.navCategory,
        ...obj,
      };
    },
    toggleHomePage(state, boo) {
      state.isHomePage = boo;
    },
    toggleShow(state) {
      state.isShow = !state.isShow;
    },
    toggClone(state) {
      state.isClone = !state.isClone;
    },
    toggleDynamicRel(state) {
      state.showDynamicRel = !state.showDynamicRel;
    },
    toggleBarrage(state) {
      state.showBarrage = !state.showBarrage;
    },
    toggleLogin(state) {
      state.showLogin = !state.showLogin;
      // if (state.showLogin) {
      //   state.userInfo = {};
      //   localStorage.removeItem("userInfo");
      // }
    },
    toggleRegister(state) {
      state.showRegister = !state.showRegister;
    },
    changeCate(state, data) {
      state.categories = data;
    },
    changeConfig(state, config) {
      state.appConfig = config;
    },
    changeUserInfo(state, info) {
      state.userInfo = info;
    },
    changeUserAsset(state, info) {
      state.userAsset = info;
    },
    changePageConfig(state, config) {
      state.pageConfig = config;
    },
    changeLoginType(state, type) {
      state.loginType = type;
    },
    changeGold(state, num) {
      state.userInfo.gold -= num;
    },
    changeTourist(state, data) {
      state.tourist = data;
    },
    changeIm(state, im) {
      state.tim = im;
    },
    changeUnder(state, count) {
      state.unReadCount = count;
    },
    changeMsgLive(state, anchor) {
      state.msgLiveAnchor = anchor;
    },
    toggleAnimation(state) {
      state.isOpenAnimation = !state.isOpenAnimation;
    },

    SET_LANG(state, locale) {
      if (state.locales.find((el) => el.code === locale)) {
        state.locale = locale;
      }
    },
    changeBarrage(state, payload) {
      state.liveBarrage = [payload];
    },
    setUserState(state, data = 0) {
      state.userState = data;
    },
    setIsLiving(state, data = false) {
      state.isLiving = data;
    },
    changeChips(state, data = []) {
      state.chips = data;
    },
    updateGifts(state, obj = {}) {
      const { key = "", data = {} } = obj;

      if (state.gifts[key]) {
        state.gifts[key] = {
          ...state.gifts[key],
          ...data,
        };
      } else {
        state.gifts[key] = data;
      }
      sessionStorage.setItem("GIFTS", JSON.stringify(state.gifts));
    },
  },

  actions: {
    getChatConfig({ commit }) {
      post({ url: "/api/live/chat_config" }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};

          if (res.status === 0) {
            commit("initialChatConfig", res.data);
          }
        }
      });
    },

    getUnderCount({ commit, state }) {
      state.tim.getConversationList().then((res) => {
        let count = 0;
        res.data.conversationList.forEach((item) => {
          if (item.conversationID === "C2Cadmin") {
            count = item.unreadCount;
          }
        });
        commit("changeUnder", count);
      });
    },
    receiveAllMessage({ commit, state }, msg) {
      msg.data.forEach((item) => {
        if (!item.payload.data) return;
        const data = JSON.parse(item.payload.data);
        console.log(data);
        if (data.Action === "AnchorStartLiveMessage") {
          commit("changeMsgLive", data.Data);
        }
        if (data.Action === "SystemMessage") {
          state.tim.getConversationList().then((res) => {
            let count = 0;
            res.data.conversationList.forEach((item) => {
              if (item.conversationID === "C2Cadmin") {
                count = item.unreadCount;
              }
            });
            commit("changeUnder", count);
          });
        }
      });
    },
    getUserInf1({ commit, dispatch }) {
      post({
        url: "/api/user/getUserInfo",
      }).then(({ data: { data } }) => {
        let { mobile = "" } = data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        commit("changeUserInfo", data);
        dispatch("getUserAsset");
      });
    },
    getUserAsset({ commit }) {
      post({
        url: "/api/user/getUserAsset",
      }).then(({ data: { data } }) => {
        commit("changeUserAsset", data);
      });
    },
    async getUserInfo({ commit, dispatch }) {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let { mobile = "" } = data.data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          mobile: data.data.mobile,
          formatPhone: data.data.formatPhone,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        commit("changeUserInfo", { ...keyValue });
      }
    },
    toLogout() {
      post({
        url: "/api/user/logout",
      });
      localStorage.removeItem("userInfo");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("uid");
    },
    checkAnchorStatus({ state, commit }) {
      if (state.userInfo && state.userInfo.id) {
        post({ url: "/api/user/checkAnchorStatus" })
          .then(({ data: { data } }) => {
            let { is_anchor = 0, is_live = 0 } = data;
            if (is_live == 1) {
              commit("setIsLiving", true);
            } else {
              commit("setIsLiving", false);
            }
          })
          .catch((err) => {
            commit("setIsLiving", false);
            console.log("err: ", err);
          });
      } else {
        commit("setIsLiving", false);
      }
    },
    getUserBackpack({ state, commit }) {
      post({
        url: "/api/live/user_backpack",
        data: { user_id: state.userInfo.id },
      })
        .then(({ data: { data } }) => {
          let ticket;
          data.user_backpack?.forEach((item) => {
            if (item.type === 105) {
              ticket = item.quantity;
            }
          });
          commit("changeUserBackpack", data.user_backpack);
          commit("changeTicket", ticket);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    // getUnreadMsg({ state, commit }) {
    //   post({
    //     url: "/api/privateChat/unreadMsg",
    //     data: { device_id: localStorage.getItem("device_no") },
    //   })
    //     .then(({ data: { data } }) => {
    //       commit("changeUnreadAnchorList", data.unread_anchor_list);
    //       commit("changeUnreadTotal", data.unread_total);
    //     })
    //     .catch((err) => {
    //       console.log("err: ", err);
    //     });
    // },
    getAnchorProfile({ state, commit }, anchorId) {
      if (!anchorId) return;
      post({
        url: "/api/groupChat/getAnchorProfile",
        data: { anchorId: anchorId },
      })
        .then(({ data: { data } }) => {
          commit("changeFansGroups", data.groups);
          commit("changeAnchorInfo", data.anchor_profile);
          commit("changeIsFollowed", data.is_attend);
          console.log(data);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    async addToGroupChat({ state, commit, dispatch }, groupId) {
      const {
        data: { msg },
      } = await post({
        url: "/api/groupChat/addToGroupChat",
        data: { group_id: groupId },
      });
      return msg;
    },
    getGroupInfo({ state, commit }) {
      post({
        url: "/api/groupChat/getGroupInfo",
        data: { group_id: state.fanGroup.group_id },
      })
        .then(({ data: { data } }) => {
          commit("changeGroupInfo", data);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    getGroupHistory({ state, commit, dispatch }, page = 1) {
      commit("changeIsLoadingMore", true);
      post({
        url: "/api/groupChat/getHistory",
        data: { group_id: state.fanGroup.fans_group_id, limit: 20, page: page },
      })
        .then(({ data: { data } }) => {
          let arr = data.FansGroupHistory;
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: this.$t("chat.noMoreInfo"),
            };
            arr = [noMoreMsg, ...state.groupMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            arr.forEach((e) => {
              if (e.uid === state.userInfo.id) {
                e.chatType = 1;
              } else {
                e.chatType = 2;
              }
            });
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time * 1000, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [...state.groupMessageList, timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.groupMessageList];
            }
          }

          commit("changeIsLoadingMore", false);
          commit("changeGroupMessageList", arr);
          dispatch("readGroupChat", state.fanGroup.fans_group_id);
        })
        .catch((err) => {
          console.log("err: ", err);
          commit("changeIsLoadingMore", false);
        });
    },
    getChatList({ state, commit }) {
      post({
        url: "/api/groupChat/getChatList",
      })
        .then(({ data: { data } }) => {
          commit("changeChatList", data.chat_list);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    async readGroupChat({ state, commit, dispatch }, fans_group_id) {
      const {
        data: { msg },
      } = await post({
        url: "/api/groupChat/read",
        data: { fans_group_id: fans_group_id },
      });
      if (msg === "SUCCESS") {
        dispatch("getChatList");
      }
    },
    onFollow({ state, commit, dispatch }) {
      if (!state.userInfo.id) {
        commit("toggleLogin");
        return;
      }
      if (state.userInfo.id == state.anchorId) {
        commit("pushToast", "不能关注自己");
        return;
      }
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: state.anchorId,
        },
      }).then(({ data: { data } }) => {
        commit("changeIsFollowed", data.type);
        let text = data.type == 1 ? "关注成功" : "取消关注";
        commit("pushToast", text);
        this.pushToast(text);
      });
    },
    getUserHistory({ state, commit, dispatch }, { uid, page = 1 }) {
      commit("changeIsLoadingMore", true);
      post({
        url: "/api/mgrChat/getHistory",
        data: { user_id: uid, limit: 20, page: page },
      })
        .then(({ data: { data } }) => {
          let arr = data.mgr_chat_history;
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: this.$t("chat.noMoreInfo"),
            };
            arr = [noMoreMsg, ...state.userMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            arr.forEach((e) => {
              if (e.sender_uid === state.userInfo.id) {
                e.chatType = 1;
              } else {
                e.chatType = 2;
              }
            });
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time * 1000, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [...state.userMessageList, timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.userMessageList];
            }
          }

          commit("changeIsLoadingMore", false);
          commit("changeUserMessageList", arr);
          dispatch("readUserChat", uid);
        })
        .catch((err) => {
          console.log("err: ", err);
          commit("changeIsLoadingMore", false);
        });
    },
    async readUserChat({ state, commit, dispatch }, user_id) {
      const {
        data: { msg },
      } = await post({
        url: "/api/mgrChat/read",
        data: { user_id: user_id },
      });
      if (msg === "SUCCESS") {
        dispatch("getChatList");
      }
    },
    getPrivateHistory({ state, commit, dispatch }, page = 1) {
      commit("changeIsLoadingMore", true);
      post({
        url: "/api/privateChat/getRecordDetail",
        data: {
          device_id: localStorage.getItem("device_no"),
          anchor_id: state.anchorId,
          duration: 0,
          page: page,
          size: 20,
        },
      })
        .then(({ data: { data } }) => {
          let arr = data.msg_group || [];
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: this.$t("chat.noMoreInfo"),
            };
            arr = [noMoreMsg, ...state.privateMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            arr.forEach((e) => {
              if (e.sender_uid === state.anchorId) {
                e.chatType = 2;
              } else {
                e.chatType = 1;
              }
            });
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time * 1000, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [...state.privateMessageList, timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.privateMessageList];
            }
          }
          commit("changeIsLoadingMore", false);
          commit("changePrivateMessageList", arr);
          if (data.msg_group) {
            dispatch(
              "readPrivateChat",
              parseInt(
                data.msg_group[data.msg_group.length - 1].send_time / 1000
              )
            );
          }
        })
        .catch((err) => {
          commit("changeIsLoadingMore", false);
          console.log("err: ", err);
        });
    },
    readPrivateChat({ state, commit, dispatch }, latestMsgStamp) {
      post({
        url: "/api/privateChat/read",
        data: {
          device_id: localStorage.getItem("device_no"),
          anchor_id: state.anchorId,
          latest_msg_stamp: latestMsgStamp,
        },
      })
        .then(({ data }) => {
          dispatch("getChatList");
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
  },
});
